"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhanceChildren = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
exports.EnhanceChildren = function (props) {
    var children = props.children, enhance = props.enhance;
    var newChildren = react_1.Children.map(children, function (child, i) {
        if (typeof child === 'object' && child !== null && 'type' in child) {
            return react_1.cloneElement(child, tslib_1.__assign({}, enhance));
        }
        return child;
    });
    return react_1.default.createElement(react_1.default.Fragment, null, newChildren);
};
//# sourceMappingURL=EnhanceChildren.js.map